import React, { useState } from 'react';

import CardLayout from '@magoosh/layouts/card';
import { paths } from 'config/path_helpers';
import fetch from 'utilities/fetch';

import TriangleExclamation from './assets/triangle_exclamation.svg';

interface Props {}

export default (props: Props) => {
  const [dismissed, setDismissed] = useState<boolean>(false);

  const dismiss = () => {
    setDismissed(true);

    fetch(paths.api.dismissBanner('sat_curriculum_admin_change_notice'), {
      method: 'PUT'
    });
  };

  if (dismissed) {
    return null;
  } else {
    return (
      <CardLayout.Card borderGradient className="align-items-center d-flex gap-s u-margin-T-m">
        <div className="flex-none">
          <img src={TriangleExclamation} alt="" />
        </div>

        <div className="small">
          <div>
            We've moved your account to the <strong>updated SAT curriculum</strong>, which better
            {' '}matches what you'll see on test day and gives you our most up-to-date SAT prep
            {' '}experience. <strong>You can switch between curriculums anytime in your Account
            {' '}Settings.</strong>
            {' '}<a onClick={dismiss} style={{ color: '#424FBC' }}>
              <strong>Got It</strong>
            </a>
          </div>
        </div>    
      </CardLayout.Card>
    );
  }
};
